import { useQueryClient } from 'react-query';
import { HeroConversation } from '../model';

export const useQueriesCache = () => {
  const queryClient = useQueryClient();

  const invalidateStoreOpeningHours = (storeId: string) => {
    queryClient.invalidateQueries(['getRetailerStoreOpeningHours', storeId]);
  };

  const invalidateAssociate = () => {
    queryClient.invalidateQueries(['getAssociateSetupState']);
    queryClient.invalidateQueries(['getAssociate']);
  };

  const invalidateShopperEvents = (shopperId: string) => {
    queryClient.invalidateQueries({
      queryKey: ['getShopperEvents', shopperId],
    });
  };

  const updateActiveHeroConversation = (
    updatedConversation: HeroConversation,
  ) => {
    queryClient.setQueryData<HeroConversation[]>(
      'getActiveHeroConversations',
      (activeConversations) => {
        if (!activeConversations) {
          return [];
        }
        const activeConversationIndex = activeConversations.findIndex(
          (c) => c.id === updatedConversation.id,
        );
        if (activeConversationIndex !== -1) {
          activeConversations[activeConversationIndex] = updatedConversation;
        }
        return activeConversations;
      },
    );
  };

  const invalidateHeroConversation = (conversationId: string) =>
    queryClient.invalidateQueries({
      queryKey: ['getHeroConversationById', conversationId],
    });

  return {
    updateActiveHeroConversation,
    invalidateStoreOpeningHours,
    invalidateAssociate,
    invalidateShopperEvents,
    invalidateHeroConversation,
  };
};
